<template>
  <header @click="$router.push('/')" @fullscreenchange="log" @fullscreenerror="log">
    <button class="btn-banner reload" @click="reload">&#8635;</button>
    <button class="btn-banner fullScreen" @click="setFullScreen">&#10530;</button>
    <p class="version">1.1.15</p>
  </header>
</template>

<script>
import store from '@/store'

export default {
  name: 'TopBanner',
  data () {
    return {
      dataStore: store
    }
  },
  methods: {
    setFullScreen (e) {
      e.stopPropagation()
      const elem = document.documentElement
      /*
      if ((window.fullScreen) || (window.innerWidth === screen.width && window.innerHeight === screen.height)) {
        console.log('isFullScreen')
        try {
        } catch (e) {
          console.warn('fake full Screen')
        }
      }
      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.mozRequestFullScreen) { // Firefox
        elem.mozRequestFullScreen()
      } else if (elem.webkitRequestFullscreen) { // Chrome, Safari & Opera
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) { // IE/Edge
        elem.msRequestFullscreen()
      }
      */
      // if (document.exitFullscreen) {
      document.exitFullscreen() // ok so this seems to work
        .then(() => {
          elem.requestFullscreen()
        })
        .catch(() => {
          elem.requestFullscreen()
        })
      // } else if (document.mozCancelFullScreen) {
      //   document.mozCancelFullScreen()
      // } else if (document.webkitExitFullscreen) {
      //   document.webkitExitFullscreen()
      // }
      // const req = document.documentElement.requestFullscreen().then(req => {
      //   console.log(req)
      // })
      //   .catch(err => {
      //     console.warn(err)
      //   })
      // console.log(req)
    },
    log (e) {
      console.log(e)
    },
    reload () {
      location.reload()
    }
  }
}
</script>

<style scoped>
  header {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 60;
    width: 100%;
    min-height: 90px;
    margin-bottom: 3%;
    /* background: url('../assets/banner.png'); */
    background: url('../assets/alary banner.png');
    background-size: contain;
    background-position: left;
    background-repeat: no-repeat;
    display: flex;
    justify-content: flex-end;
  }
  .reload {
    transform: rotateZ(90deg);
  }
  button.btn-banner {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 4.5rem;
    height: 4.5rem;
    font-size: 2.5em;
    aspect-ratio: 1;
    border-radius: 50%;
    border: none;
    background-color: #D3B06D;
    color: white;
  }
  @media screen and (max-width: 680px) {
    button.btn-banner {
      width: 3.5rem;
      height: 3.6rem;
      font-size: 2em;
    }
  }
  @media screen and (min-width: 1500px) {
    header {
      width: 100%;
      min-height: 120px;
      margin-bottom: 2%;
    }
  }
  p.version {
    position: absolute;
    top: 0;
    left: 48%;
    margin: 0;
    font-weight: 300;
    font-size: 0.8em !important;
  }
</style>
